import { useRef } from 'react';
import ReactQuill from 'react-quill';
import '../../utils/highlight';
//
import { Typography } from '@mui/material';
import EditorToolbar, { formats } from './EditorToolbar';
import { StyledEditor } from './styles';
import { EditorProps } from './types';
import { translateKey } from 'src/locales/translate';
import DictationMicButton from 'src/sections/@dashboard/dictation/components/DictationMicButton';


// ----------------------------------------------------------------------

export default function Editor({
  id = 'minimal-quill',
  placeholder = translateKey("hardcoded.stworz_notatke"),
  error,
  value,
  onChange,
  simple = false,
  helperText,
  sx,
  disabled,
  enableDictation,
  ...other
}: EditorProps) {
  const quillRef = useRef<ReactQuill>(null);
  const modules = {
    toolbar: {
      container: `#${id}`,
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true,
    },
    syntax: false,
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <>
      <StyledEditor
        sx={{
          ...(error && {
            border: (theme) => `solid 1px ${theme.palette.error.main}`,
          }),
          ...sx,
        }}
      >
        <EditorToolbar
          id={id}
          isSimple={simple}
          rightSlot={
            enableDictation && !disabled ? (
              <DictationMicButton quillRef={quillRef} disabled={disabled} />
            ) : undefined
          }
        />
        <ReactQuill
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          readOnly={disabled}
          {...other}
          ref={quillRef}
        />
      </StyledEditor>

      {helperText && (
        <Typography
          sx={{
            mx: '14px',
            mt: '8px',
            color: error ? 'error.main' : 'text.secondary',
          }}
          variant="caption"
        >
          {helperText}
        </Typography>
      )}
    </>
  );
}
